module.exports = __webpack_public_path__ + "img/gjcjl.39e1a1c4.jpg";